import { IStripeCheckoutWidgetData, IStripeCheckoutWidgetStyle } from "@pageBuilder/typings";
import { WidgetRendererBase } from "./widget-renderer-base";

export class StripeCheckoutWidgetRenderer extends WidgetRendererBase<IStripeCheckoutWidgetData> {

    protected createNewInternal(): HTMLElement {
        return this.createWidgetElement("stripeCheckoutWidget");
    }

    protected renderInternal(element: HTMLElement, data: IStripeCheckoutWidgetData): HTMLElement {
        this.clearAlignmentClasses(element);

        let content = element.querySelector(".widget-content") as HTMLElement;
        if (!content) {
            content = this.createContentElement();
            element.appendChild(content);
        }

        if (this.isEditorRendering) {
            this.renderPlaceholder(data, content);
        } else {
            content.innerHTML = this.createRenderedHtmlAttribute(element.id, data);
            this.executeScripts(content);
        }

        this.renderStyles(element, data);

        return element;
    }

    private clearAlignmentClasses(element: HTMLElement): void {
        element.classList.remove("alignable", "justify-start", "justify-center", "justify-end");
    }

    protected renderStyles(element: HTMLElement, data: IStripeCheckoutWidgetData): void {
        this.renderBaseStyles(element, data.style);
    }

    private renderBaseStyles(element: HTMLElement, style: IStripeCheckoutWidgetStyle | null): void {
        element.classList.add("alignable");
        element.classList.add(style?.alignment ? `justify-${style?.alignment}` : "justify-center");

        this.animationRenderer.setAnimationStyles(element, style?.animation);
    }

    private createRenderedHtmlAttribute(widgetId: string, data: IStripeCheckoutWidgetData): string {
        // https://stripe.com/docs/js/element/other_methods/update?type=card

        const submitType = data.submitType === "subscribe" ? "auto" : data.submitType;
        const mode = data.submitType !== "subscribe" ? "payment" : "subscription";

        return `<button class="stripe-checkout">${data.buttonLabel}</button>
                <script src="https://js.stripe.com/v3/" defer></script>
                <script>
                    function addBtnClickHandler() {
                        document.querySelector('#${widgetId} > div > button').addEventListener('click', function() {
                            var href = window.location.href;
                            var successUrl = '${data.successUrl || ""}' || href;
                            Stripe('${data.apiKey}').redirectToCheckout({
                                lineItems: [{
                                    price: '${data.sku}',
                                    quantity: parseInt('${data.quantity ?? 1}')
                                }],
                                submitType: '${submitType}',
                                mode: '${mode}',
                                billingAddressCollection: '${data.billingAddressCollection}',
                                successUrl: successUrl,
                                cancelUrl: href,
                            }).then(function (result) {
                                if (result.error) alert('Error: ' + result.error.message);
                            });
                        });
                    }
                    
                    if (document.readyState === 'interactive' || document.readyState === 'complete') {
                        addBtnClickHandler();
                    } else {
                        window.addEventListener('DOMContentLoaded', addBtnClickHandler);
                    }
                </script>`;
    }

    private renderPlaceholder(data: IStripeCheckoutWidgetData, element: HTMLElement): void {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }

        const button = document.createElement("button");
        button.classList.add("stripe-checkout");
        button.textContent = data.buttonLabel;
        element.appendChild(button);
    }

    protected getContentSelectorsInternal(element: HTMLElement): Array<string> {
        return [`#${element.id}`];
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected cleanupInternal(element: HTMLElement): void {
        // nothing
    }

}
